import { createFileRoute, redirect } from '@tanstack/react-router'

import { firstAreaUnder } from '@/constants/system-navigation'
import { currentUserRoles } from '@/stores/use-app-store'

/** The group has no page of its own; its first page stands in. */
export const Route = createFileRoute('/internal/system/operations/')({
  beforeLoad: () => {
    throw redirect({ to: firstAreaUnder('operations', currentUserRoles()) })
  },
})
